import { Button, LuIcon, Text } from "@overmap-ai/blocks"
import { type Asset, type AssetTypeIdentifier, OrganizationAccessLevel, type Stored } from "@overmap-ai/common"
import { memo, useCallback } from "react"

import { useUserOrganizationAccess } from "../../hooks/users"
import { modelIconMapping } from "../../mappings/icons"
import { sdk } from "../../sdk"
import { useAppSelector } from "../../store"
import { selectLatestAssetTypeIdentifierValueOfAsset } from "../../store/selectors/assets"
import { IdentifierEditorPopover } from "../Popovers/IdentifierEditorPopover"

interface AssetTypeIdentifiersListitemProps {
	asset: Stored<Asset>
	assetTypeIdentifier: Stored<AssetTypeIdentifier>
}

export const AssetTypeIdentifiersListItem = memo<AssetTypeIdentifiersListitemProps>((props) => {
	const { asset, assetTypeIdentifier } = props

	const isBasic = useUserOrganizationAccess(OrganizationAccessLevel.BASIC)
	const assetTypeIdentifierValue = useAppSelector(
		selectLatestAssetTypeIdentifierValueOfAsset(asset.uuid, assetTypeIdentifier.uuid),
	)

	const handleSave = useCallback(
		(value: string) => {
			void sdk.assetTypeIdentifierValues.add({
				value: value,
				asset: asset.uuid,
				asset_type_identifier: assetTypeIdentifier.uuid,
			})
		},
		[asset.uuid, assetTypeIdentifier.uuid],
	)

	return (
		<IdentifierEditorPopover initialValue={assetTypeIdentifierValue?.value ?? ""} onSave={handleSave} size="xs">
			<Button
				type="button"
				className="min-w-0 max-w-full shrink overflow-hidden"
				size="sm"
				accentColor="base"
				variant="soft"
				disabled={!isBasic}
			>
				<LuIcon icon={modelIconMapping.identifier} />
				<Text className="truncate">{assetTypeIdentifier.name}</Text>
				{assetTypeIdentifierValue?.value ? (
					<Text className="truncate" highContrast>
						{assetTypeIdentifierValue.value}
					</Text>
				) : (
					<Text className="text-(--base-a10)">No value</Text>
				)}
			</Button>
		</IdentifierEditorPopover>
	)
})
AssetTypeIdentifiersListItem.displayName = "AssetTypeIdentifiersListItem"
